module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lKDIH"))).then(() => parcelRequire('d0iPb'));